import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import {
  type ComponentType,
  type ReactNode,
  createContext,
  useContext,
} from "react";
import type { IGifs } from "../types";

type GifsViewType = "dialog" | "panel";

interface GifsCtxValue {
  view?: GifsViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  onSelect?: (item: IGifs) => void;
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
}

const GifsCtx = createContext<GifsCtxValue | undefined>(undefined);

export const GifsProvider = ({
  children,
  view = "panel",
  isMultiSelect,
  onSelect,
  elementWrapper,
  selectedItems,
}: {
  children: ReactNode;
  view?: GifsViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
  onSelect?: (item: IGifs) => void;
}) => {
  return (
    <GifsCtx.Provider
      value={{
        view,
        isMultiSelect,
        onSelect,
        selectedItems,
        elementWrapper,
      }}
    >
      {children}
    </GifsCtx.Provider>
  );
};

export const useGifsCtx = () => {
  const ctx = useContext(GifsCtx);
  if (!ctx) throw new Error("useGifsCtx must be used within a GifsProvider");
  return ctx;
};
